// src/api/departments.js
import api from "./api"; // centralized axios instance with baseURL and token

// 📌 Fetch all departments
export const getDepartments = async () => {
  try {
    const res = await api.get("/departments/");
    return res.data;
  } catch (err) {
    console.error("Error fetching departments:", err);
    throw err;
  }
};

// ✅ Create a new department
export const createDepartment = async (data) => {
  try {
    const res = await api.post("/departments/", data);
    return res.data;
  } catch (err) {
    console.error("Error creating department:", err);
    throw err;
  }
};

// 🔄 Update a department
export const updateDepartment = async (id, data) => {
  try {
    const res = await api.put(`/departments/${id}/`, data);
    return res.data;
  } catch (err) {
    console.error("Error updating department:", err);
    throw err;
  }
};

// ❌ Delete a department
export const deleteDepartment = async (id) => {
  try {
    const res = await api.delete(`/departments/${id}/`);
    return res.data;
  } catch (err) {
    console.error("Error deleting department:", err);
    throw err;
  }
};
